export const catchPromiseCancel = (err) => {
  if (err?.message?.match('canceled')) {
    return
  } else {
    throw err
  }
}
